<script setup lang="ts">
import type { SuggestionProfile } from "./context";
import { useDisplayName } from "ls/features/user/useDisplayName";
import UserAvatar from "ls/features/user/UserAvatar.vue";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<{
  user: SuggestionProfile;
}>();

const displayName = useDisplayName(() => props.user);
</script>

<template>
  <SuggestionListItem>
    <template #icon>
      <UserAvatar class="size-4 shrink-0" :user="user" />
    </template>
    {{ displayName }}
  </SuggestionListItem>
</template>
